import { merge } from 'lodash'

const initialState = {
  isFetching: false,
  isFetched: false,
  isError: false,
  isSuccess: false,
  data: {},
  lists: {
    listOccupations: [],
    listSituations: [],
    listActivityAreas: []
  }
}

export const ACTION_TYPES = {
  BUSINESS_INFO_REQUEST: 'BUSINESS_INFO_REQUEST',
  BUSINESS_INFO_SUCCESS: 'BUSINESS_INFO_SUCCESS',
  BUSINESS_INFO_ERROR: 'BUSINESS_INFO_ERROR',
  BUSINESS_INFO_CHANGE_OCCUPATION: 'BUSINESS_INFO_CHANGE_OCCUPATION',
  BUSINESS_INFO_CHANGE_: 'BUSINESS_INFO_CHANGE_ACTIVITY_AREA',
  BUSINESS_INFO_CLEAR_FORM: 'BUSINESS_INFO_CLEAR_FORM'
}

const handleRequest = state => ({
  ...state,
  isFetching: true
})

const handleSuccess = (state, payload) => {
  const data = payload.professionalinfo.data
  const listOccupations = payload.occupations.data.filter(({ isJob }) => isJob)
  const listSituations = payload.occupations.data
  const listActivityAreas = payload.activityAreas.data
  const objDefaultToSelect = { key: '', value: '' }
  let situation = { ...objDefaultToSelect }
  let occupation = { ...objDefaultToSelect }
  let activityArea = { ...objDefaultToSelect }
  const noProfession = !data.working

  if (noProfession) {
    situation = listSituations.find(item => String(data.occupationId) === String(item.key))
  } else {
    occupation = listOccupations.find(item => data.occupationId === item.key)
  }

  const { showActivityArea = false, requiredCommercialData = false } = noProfession ?
    situation : occupation

  if (showActivityArea) {
    activityArea = listActivityAreas.find(item => data.activityArea === item.key)
  }

  let newState = {
    isFetching: false,
    isFetched: true,
    isError: false,
    isSuccess: true,
    lists: {
      listOccupations,
      listSituations,
      listActivityAreas
    },
    data: {
      ...state.data,
      activityArea,
      occupation,
      situation,
      noProfession,
      working: !noProfession,

      showActivityArea,
      requiredCommercialData
    }
  }
  if (showActivityArea) {
    newState = {
      ...newState,
      activityArea
    }
  }
  if (requiredCommercialData) {
    const phone = data.phone ? `${data.phone.areaCode}${data.phone.phoneNumber}` : ''
    newState = merge(newState, {
      data: {
        cnpjNumber: data.cnpjNumber,
        institutionName: data.institutionName,
        phone
      }
    })
  }
  return newState
}

const handleError = state => ({
  ...state,
  isFetching: false,
  isFetched: true,
  isError: true,
  isSuccess: false
})

export const getBusinessInfo = () => ({
  type: ACTION_TYPES.BUSINESS_INFO_REQUEST
})

export const clearForm = () => ({
  type: ACTION_TYPES.BUSINESS_INFO_CLEAR_FORM
})

const businessInfo = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.BUSINESS_INFO_REQUEST:
      return handleRequest(state, payload)
    case ACTION_TYPES.BUSINESS_INFO_SUCCESS:
      return handleSuccess(state, payload)
    case ACTION_TYPES.BUSINESS_INFO_ERROR:
      return handleError(state, payload)
    case ACTION_TYPES.BUSINESS_INFO_CLEAR_FORM:
      return initialState
    default:
      return state
  }
}

export default businessInfo
